import { Link } from "react-router-dom";

const Three = () => {
  return (
    <>
      <div className="container-fluid jumbotron jumbotron-image py-5">
        <div className="container">
          <h1 className="display-3 fw-bold text-white">Simpozion #3</h1>
        </div>
      </div>
      <div className="container">
        <nav aria-label="breadcrumb" className="mb-3 mt-4 ms-3">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/">Acasă</Link>
            </li>
            <li className="breadcrumb-item">
              <Link to="/evenimente">Evenimente</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Simpozion #3
            </li>
          </ol>
        </nav>
        <div className="container history">
          <div className="row">
            <div className="col-lg-12 bg-light rounded p-4">
              <h2 className=" pb-1 mb-4 fst-italic">Invitație</h2>
              <p>
                Asociația Oncohem Cluj-Napoca organizează sub egida Institutului
                Oncologic Ion Chiricuță Cluj-Napoca simpozionul intitulat{" "}
                <b>
                  “ACTUALITĂȚI ÎN DIAGNOSTICUL ȘI TRATAMENTUL BOLILOR
                  LIMFOPROLIFERATIVE CRONICE DE LINIE B”
                </b>
                , desfășurat în 29.11.2025 la Cluj-Napoca, la Hotel Golden
                Tulip.
              </p>
              <p>
                Simpozionul are ca și scop o abordare multidisciplinară a
                acestui grup de afecțiuni, incluzând leucemia limfatică cronică,
                limfoamele non-hodgkin cu celule B, mielomul multiplu și
                macroglobulinemia Waldenstrom, cu participarea specialiștilor
                din domeniul hematologiei dar și anatomopatologi, specialiști în
                imagistica și genetica medicală.
              </p>
              <p>
                Pe lângă prezentările teoretice, simpozionul va cuprinde și un
                workshop despre metodele de diagnostic ale sindromului
                ganglionar și abordarea lor imagistică.
              </p>
              <p>
                Manifestarea se adresează in principal medicilor hematologi, dar
                si specialistilor in imagistica medicala si medicilor de
                laborator.
              </p>
              <p>
                Dorim ca această manifestare științifică să fie una interactivă
                și să faciliteze în viitor colaborarea între specialiștii
                implicați în diagnosticarea și tratarea acestor afecțiuni.
              </p>
              <p>
                Participarea este gratuită, înscrierea se poate efectua
                utilizând linkul de mai jos:
              </p>
              <p className="mb-1">
                Formular înscriere:{" "}
                <a href="https://docs.google.com/forms/d/e/1FAIpQLSdJs01brY2Rqsbr5ixfkKafBfPVgLOgR1qN5RVnMvdfQTnhEA/viewform">
                  Link
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Three;
